import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Lock, Upload, Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import UpgradeDialog, { PRO_FEATURES } from "./UpgradeDialog";

export function ProGate({ feature }) {
    const [open, setOpen] = useState(false);
    return (
        <div className="rounded-2xl border border-accent/30 bg-gradient-to-br from-secondary to-card p-8 text-center" data-testid="pro-gate">
            <UpgradeDialog open={open} onOpenChange={setOpen} feature={feature} />
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl border border-accent/30 bg-accent/15"><Lock className="h-6 w-6 text-accent" /></div>
            <h2 className="mt-5 font-heading text-xl font-bold text-foreground">{feature} is a Pro feature</h2>
            <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">Sift Pro is £4.99/month and typically finds far more than that in the first look. Cancel anytime.</p>
            <ul className="mx-auto mt-5 max-w-sm space-y-2 text-left text-sm text-foreground/85">
                {PRO_FEATURES.map(({ icon: Icon, text }) => <li key={text} className="flex items-start gap-2"><Icon className="mt-0.5 h-4 w-4 shrink-0 text-primary" />{text}</li>)}
            </ul>
            <Button onClick={() => setOpen(true)} data-testid="pro-gate-upgrade-btn" className="mt-6 bg-primary text-primary-foreground hover:bg-primary/90 font-semibold">
                <Crown className="mr-2 h-4 w-4" /> Unlock for £4.99/mo
            </Button>
        </div>
    );
}

export function EmptyData({ onLoaded }) {
    const navigate = useNavigate();
    const [busy, setBusy] = useState(false);
    const demo = async () => {
        setBusy(true);
        try {
            await api.post("/statements/demo");
            toast.success("Demo statement loaded — 3 months of transactions");
            onLoaded ? onLoaded() : navigate("/dashboard");
        } catch (e) { toast.error("Could not load demo data"); } finally { setBusy(false); }
    };
    return (
        <div className="rounded-2xl border border-dashed border-border bg-card/60 p-10 text-center" data-testid="empty-data">
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/15"><Upload className="h-6 w-6 text-primary" /></div>
            <h2 className="mt-5 font-heading text-xl font-bold text-foreground">No transactions yet</h2>
            <p className="mx-auto mt-2 max-w-md text-sm text-muted-foreground">Upload a CSV or PDF statement from your bank and Sift will explain where your money went. Or try it with realistic demo data first.</p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
                <Button onClick={() => navigate("/upload")} data-testid="empty-upload-btn" className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold"><Upload className="mr-2 h-4 w-4" /> Upload a statement</Button>
                <Button variant="outline" onClick={demo} disabled={busy} data-testid="empty-demo-btn" className="border-border bg-secondary text-foreground">
                    {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Sparkles className="mr-2 h-4 w-4" />} Load demo statement
                </Button>
            </div>
        </div>
    );
}

export function Spinner() {
    return <div className="flex justify-center py-24" data-testid="loading"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;
}
